import {Account} from "@/entities/auth/Account";
import {Voting} from "@/entities/voting/Voting";
import {Property} from "@/entities/questionaire/Property";
import {Branch} from "@/entities/Branch";
import {VotingType} from "@/entities/voting/VotingType";
import {VotingResult} from "@/entities/voting/VotingResult";
import {VotesType} from "@/entities/voting/VotesType";
import {VotingStatus} from "@/entities/voting/VotingStatus";
import {Group} from "@/entities/questionaire/Group";

export class QuestionVotingDetail extends Voting {
    groupWithNewQuestion: Group;

    constructor(id: number, name: string, branch: Branch, type: VotingType, status: VotingStatus, votes: VotingResult, initiator: Account, currentVote: VotesType, groupWithNewQuestion: Group) {
        super(id, name, branch, type, status, votes, initiator, currentVote);
        this.groupWithNewQuestion = groupWithNewQuestion;
    }

    static createVotingDetail(obj: any) {
        const voting = Voting.createVoting(obj);
        const property = Property.createProperty(obj.newQuestion);
        const group = new Group(obj.newQuestion.group.id, obj.newQuestion.group.name, [property])

        return new QuestionVotingDetail(voting.id, voting.name, voting.branch, voting.type, voting.status, voting.votes, voting.initiator, voting.currentVote, group);
    }
}
